(function comp(name) {
    const selector = $(`.${name}`);

    if (selector.length) {
        doc.on('click', '[data-gallery-trigger-click]', function(){
            $('[data-gallery-first-image]').click();
        });
    }
})("comp_site_detail_full");